const secondsConvert = (value) => {
	var hours = Math.floor(value / 3600),
		minutes = Math.floor((value - (hours * 3600)) / 60),
		seconds = value - (hours * 3600) - (minutes * 60),
		dseconds = seconds < 10 ? '0' + seconds : seconds;
	return minutes + ':' + dseconds;
}

export default secondsConvert;
